import React from 'react';
import { PropTypes } from 'prop-types';
import { formatNumericDate } from '../../../utils/dates';

const Route = ({ route }) => {
  const {
    name, date, description, number_of_stops: numberOfStops,
  } = route;
  const sitesLabel = numberOfStops != null ? `${numberOfStops} ${numberOfStops === 1 ? 'site' : 'sites'}` : '';

  return (
    <a href={`/routes/${route.id}/edit?mode=map`} className="flex items-center relative py-2 px-4 text-black gap-4 rounded-lg bg-vamos-v-light-gray mb-2 hover:no-underline hover:text-black hover:bg-vamos-light-gray">
      <h4 className="flex items-center text-base font-medium gap-2 text-black min-w-[72px]">
        {formatNumericDate(date)}
      </h4>
      <h3 className="flex items-center flex-1 min-w-0 text-base font-semibold m-0 gap-3">
        <span className="min-w-0 truncate">
          {name}
          {description && (
            <span className="text-sm font-normal text-vamos-grey-70 ml-3">{description}</span>
          )}
        </span>
        {sitesLabel && (
          <span className="flex-none text-sm font-semibold text-vamos-green1 whitespace-nowrap">
            {sitesLabel}
          </span>
        )}
      </h3>
    </a>
  );
};

export default Route;

Route.propTypes = {
  route: PropTypes.object.isRequired,
};
